import { Card, CircularProgress, Divider, Grid, makeStyles } from "@material-ui/core";
import * as React from "react";
import { useNotify } from "react-admin";
import { Form } from "react-final-form";
import { SectionTitle } from "../../../src/Components/SectionTitle";
import { Separator } from "../../../src/Components/Separator";
import CustomLinearProgress from "../../../src/Components/Progress/LinearProgress";
import { useAppDataProvider } from "../../../src/dataprovider";
import { TextInput } from "react-admin";
import { required } from "react-admin";
import { Toolbar } from "react-admin";
import { Button } from "react-admin";
import { Add } from "@material-ui/icons";
import { NumberInput } from "react-admin";
import { SelectInput } from "react-admin";
import { AbilityLimitStatusList } from "./Constant/Source";
import AbilityCreateModel from "./Model/AbilityCreateModel";
const useStyles = makeStyles(theme => ({
  toolbar: {
    display: "flex",
    justifyContent: "end",
  },
  gridItem: {
    margin: "0px 10px",
  },
}));
export const AbilityCreate = props => {
  const classes = useStyles(props);
  const notify = useNotify();
  const dataProvider = useAppDataProvider();
  const [loading, setLoading] = React.useState(false);
  var formRef: any = null;

  const handleSubmit = values => {
    var createModel: AbilityCreateModel = new AbilityCreateModel();
    createModel.Pn = values.pn;
    createModel.Description = values.description;
    createModel.Spt = values.spt;
    createModel.LimitStatus = values.limitStatus;
    createModel.LimitNote = values.limitNote;
    createModel.OperationPlace = values.operationPlace;
    createModel.OperationPlaceCode = values.operationPlaceCode;
    createModel.Remarks = values.remarks;
    setLoading(true);
    dataProvider
      .postAbilityControl(createModel)
      .then(result => {
        notify(`Record created`, "success", false, true);
        formRef?.reset?.();
      })
      .catch(result => {
        notify(`${result}`, "error", false, true);
      })
      .finally(() => {
        setLoading(false);
        props?.refresh?.();
      });
  };
  return (
    <>
      <Form
        onSubmit={handleSubmit}
        render={({ handleSubmit, form, values }) => {
          formRef = form;
          return (
            <form onSubmit={handleSubmit}>
              <CustomLinearProgress loading={loading} periodTime={100} />
              <Card style={{ padding: "15px" }}>
                <Grid container spacing={0}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <SectionTitle label="Create Ability Control" />
                    <Divider />
                    <Separator />
                  </Grid>
                  <Grid item xs={12} sm={12} md={5} lg={5}>
                    <TextInput source="pn" label="Pn" fullWidth validate={required()} variant="outlined" />
                    <SelectInput
                      label="Limit Status"
                      source="limitStatus"
                      choices={AbilityLimitStatusList}
                      optionText="label"
                      optionValue="id"
                      fullWidth
                      variant="outlined"
                      validate={required()}
                    />
                    <TextInput
                      source="operationPlace"
                      label="Operation Place"
                      fullWidth
                      validate={required()}
                      variant="outlined"
                    />
                    <TextInput
                      source="description"
                      label="Description"
                      fullWidth
                      multiline
                      minRows={4}
                      validate={required()}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={1} />
                  <Grid item xs={12} sm={12} md={5} lg={5}>
                    <NumberInput source="spt" label="Spt" fullWidth validate={required()} variant="outlined" />
                    <TextInput
                      source="limitNote"
                      label="Limit Note"
                      fullWidth
                      validate={required()}
                      variant="outlined"
                    />
                    <TextInput
                      source="operationPlaceCode"
                      label="Operation Place Code"
                      fullWidth
                      validate={required()}
                      variant="outlined"
                    />
                    <TextInput
                      source="remarks"
                      label="Remarks"
                      fullWidth
                      multiline
                      minRows={4}
                      validate={required()}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
                <Toolbar {...props} placeholder="" className={classes.toolbar}>
                  <Button
                    label={loading ? "Creating!" : "Create"}
                    disabled={loading}
                    size="medium"
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                  >
                    {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                  </Button>
                  )
                </Toolbar>
              </Card>
            </form>
          );
        }}
      />
    </>
  );
};

export default AbilityCreate;
